import React, {  useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
// import { Formik, Form, Field } from 'formik';
// import styles1 from './styles/viewUser.module.css';
import styles from './styles/detail-view.module.css';
// import avatar from "utils/assets/Profile_Photo.svg";
// import Breadcrumbs from '@mui/material/Breadcrumbs';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';


// Oxygen icon removed — not used in the updated TileCard

// removed unused environment/metric icons to avoid lint errors
// import { ReactComponent as AltitudeIcon } from '../../utils/assets/Path3.svg';
// import { ReactComponent as AirQualityIcon } from '../../utils/assets/Path4.svg';
// import { ReactComponent as HumidityIcon } from '../../utils/assets/path5.svg';
// import { ReactComponent as BarometricIcon } from '../../utils/assets/path6.svg';
// import { ReactComponent as HeartIcon } from '../../utils/assets/heart.svg';

import { useLocation, useNavigate } from 'react-router-dom';
import ExitConfirmDialog from '../Report/ExitConfirmDialog';


// import { Button,  } from '@material-ui/core';
// import InfoIcon from '@mui/icons-material/Info';
// import { ReactComponent as EditIconTakeNote } from '../../utils/assets/editIcon_TakeNote.svg';
// import AddPrivateNote from './add_private_note';
import useSSE from '../../utils/hooks/useSSE';
import { getAirQualityStatus, getAirQualityStatusColor } from '../../utils/air-quality';
import { getStripeColorFromSpo2 } from '../../utils/stripe-color';
// SingleVital is no longer used in tile demo view
// import { SingleVital } from './SingleVital';
// import {Line} from "recharts";

function StatItem({ label, value, unit, sub }) {
  return (
    <div className={styles.statItem}>
      <span className={styles.statLabel}>{label}</span>
      <div className={styles.statValueRow}>
        <span className={styles.statValue}>{value}</span>
        {unit ? <span className={styles.statUnit}>{unit}</span> : null}
      </div>
      {sub ? <span className={styles.statSub}>{sub}</span> : null}
    </div>
  );
}

function BottomItem({ label, value, status, statusColor }) {
  return (
    <div className={styles.bottomItem}>
      <div className={styles.bottomLabel}>{label}</div>
      <div className={styles.bottomValue}>
        {value}
        {status ? (
          <span
            style={{
              marginLeft: 4,
              color: statusColor || 'inherit',
              textTransform: 'none',
            }}
          >
            {status}
          </span>
        ) : null}
      </div>
    </div>
  );
}

function CardSmall({
    name,
    avatarUrl,
    air_quality,
    heart_rate,
    spo2,
    spv,
    pi,
    hrv,
    altitude,
    humidity,
    temp,
    onClick,
}) {
    const stripeColor = getStripeColorFromSpo2(spo2);
    const airQualityStatus = air_quality ? getAirQualityStatus(air_quality) : '';
    const airQualityColor = air_quality ? getAirQualityStatusColor(air_quality) : undefined;
    const hasHeartRate =
        heart_rate !== undefined &&
        heart_rate !== null &&
        heart_rate !== "--";

    return (
        <div className={styles.card} onClick={onClick}>
            <div className={styles.cardHeader}>
                 <Avatar
                    alt={name}
                    src={avatarUrl}
                    sx={{ width: 40, height: 40 }}
                />
                <div className={styles.name}>{name}</div>
            </div>

            {/* stripe color logic from TileCard */}
            <div
                className={styles.cardAccent}
                style={{ background: stripeColor }}
            />

            <div className={styles.cardBody}>
                <div className={styles.colLeft}>
                    <div className={styles.sectionTitle}>Oxygen</div>
                    <div className={styles.oxygenRow}>
                        <span
                            className={styles.oxygenValue}
                            style={{ color: stripeColor }}
                        >
                            {spo2 ?? "--"}
                        </span>
                        <span className={styles.percent}>%</span>
                    </div>

                    <div className={styles.sectionTitle}>Pulse Rate</div>
                    <div className={styles.heartRateRow}>
                        <span
                            className={styles.heartValue}
                            style={hasHeartRate ? undefined : { color: stripeColor }}
                        >
                            {hasHeartRate ? heart_rate : "--"}
                        </span>
                        <span className={styles.heartUnit}>bpm</span>
                    </div>
                </div>

                <div className={styles.colRight}>
                    <StatItem
                        label="SpO₂ Variability"
                        value={spv ?? "--"}
                        unit="mL/s"
                    />
                    <StatItem
                        label="Perfusion Index"
                        value={pi ?? "--"}
                        unit="%"
                    />
                    <StatItem
                        label="HRV"
                        value={hrv ?? "--"}
                        unit="ms"
                    />
                </div>
            </div>

            {/* <div className={styles.divider} /> */}
            <div className={styles.cardFooter}>
                <BottomItem
                    label="Humidity"
                    value={
                        humidity !== undefined && humidity !== null
                            ? `${humidity} %`
                            : "-- %"
                    }
                />
                <BottomItem label="Altitude"   value={
                        altitude !== undefined && altitude !== null
                            ? `${altitude} feet`
                            : "-- feet"
                    }/>
                <BottomItem label="Weather" value={
                        temp !== undefined && temp !== null
                            ? `${temp} °F`
                            : "-- °F"
                    }/>
                <BottomItem
                    label="Air Quality Index"
                    value={air_quality ?? "--"}
                    status={airQualityStatus ? airQualityStatus.toLowerCase() : ''}
                    statusColor={airQualityColor}
                />
            </div>
        </div>
    );
}

function CardLarge({
    name,
    avatarUrl,
    spo2,
    heart_rate,
    spv,
    pi,
    hrv,
    altitude,
    humidity,
    temp,
    air_quality,
    onClick,
}) {
    const stripeColor = getStripeColorFromSpo2(spo2);
    const airQualityStatus = air_quality ? getAirQualityStatus(air_quality) : '';
    const airQualityColor = air_quality ? getAirQualityStatusColor(air_quality) : undefined;
    const hasHeartRate =
        heart_rate !== undefined &&
        heart_rate !== null &&
        heart_rate !== "--";

    return (
        <div className={styles.cardLarge} onClick={onClick}>
            <div className={`${styles.cardHeader} ${styles.cardHeaderLarge}`}>
                <Avatar
                    alt={name}
                    src={avatarUrl}
                    sx={{ width: 40, height: 40 }}
                />
                <div className={styles.name}>{name}</div>
            </div>

            <div
                className={styles.cardAccentLarge}
                style={{ background: stripeColor }}
            />

            <div className={styles.cardBodyLarge}>
                <div className={styles.colLeftLarge}>
                    <div className={styles.sectionTitle}>Oxygen</div>
                    <div className={styles.oxygenRow}>
                        <span
                            className={styles.oxygenValue}
                            style={{ color: stripeColor }}
                        >
                            {spo2 ?? "--"}
                        </span>
                        <span className={styles.percent}>%</span>
                    </div>

                    <div className={styles.sectionTitle}>Pulse Rate</div>
                    <div className={styles.heartRateRow}>
                        <span
                            className={styles.heartValue}
                            style={hasHeartRate ? undefined : { color: stripeColor }}
                        >
                            {hasHeartRate ? heart_rate : "--"}
                        </span>
                        <span className={styles.heartUnit}>bpm</span>
                    </div>
                </div>

                <div className={styles.midColLarge}>
                    <StatItem
                        label="SpO₂ Variability"
                        value={spv ?? "--"}
                        unit="mL/s"
                    />
                    <StatItem
                        label="Perfusion Index"
                        value={pi ?? "--"}
                        unit="%"
                    />
                    <StatItem
                        label="HRV"
                        value={hrv ?? "--"}
                        unit="ms"
                    />
                </div>

                <div className={styles.envColLarge}>
                    <div >
                        <div className={styles.envLabel}>Humidity</div>
                        <div className={styles.envRow}>
                            <span className={styles.envValue}>
                                {humidity ?? "--"}
                            </span>
                            <span className={styles.envUnit}>%</span>
                        </div>
                    </div>
                    <div className={styles.envItemLarge}>
                        <div className={styles.envLabel}>Altitude</div>
                        <div className={styles.envRow}>
                            <span className={styles.envValue}>
                                {altitude ?? "--"}
                            </span>
                            <span className={styles.envUnit}>feet</span>
                        </div>
                    </div>
                    <div className={styles.envItemLarge}>
                        <div className={styles.envLabel}>Weather</div>
                        <div className={styles.envRow}>
                            <span className={styles.envValue}>
                                {temp ?? "--"}
                            </span>
                            <span className={styles.envUnit}>°F</span>
                        </div>
                    </div>
                    <div className={styles.envItemLarge}>
                        <div className={styles.envLabel}>Air Quality Index</div>
                        <div className={styles.envRow}>
                            <span className={styles.envValue}>
                                {air_quality ?? "--"}
                            </span>
                            {airQualityStatus ? (
                                <span
                                    className={styles.envUnit}
                                    style={{
                                        color: airQualityColor || 'inherit',
                                        textTransform: 'none',
                                    }}
                                >
                                    {airQualityStatus.toLowerCase()}
                                </span>
                            ) : null}
                        </div>
                    </div>
                </div>

                <div className={styles.vDividerRight} />
            </div>
        </div>
    );
}


export default function DetailView() {
   
    const navigate = useNavigate();
    const location = useLocation();
    const item = location.state;


    // eslint-disable-next-line
    const [members, setMembers] = useState([]);
    // const [user, setUser] = useState([]);
    
    // const [open, setOpen] = useState(false);
    const [showExitConfirm, setShowExitConfirm] = useState(false);
    // const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
   

    const [selectedUsers, setSelectedUsers] = useState([]);

    const openIndividualView = React.useCallback(
        (tile) => {
            // Try to find the original player object from selectedPlayers using the tile id
            const originalPlayer =
                (item.selectedPlayers || []).find((p) => {
                    const key =
                        p?.user_id || p?.member_id || p?.id;
                    return String(key) === String(tile.id);
                }) || null;

            navigate("/individualView", {
                state: { ...(originalPlayer || item), fromCompare: true },
            });
        },
        [item, navigate]
    );

    const handleConfirmExit = () => {
        setShowExitConfirm(false);
        navigate(-1);
    };

    const handleSSEData = React.useCallback((parsedData) => {
        console.log('SSE data received:', parsedData);
        if (parsedData && parsedData.data) {
            const data = parsedData.data;
            // Update selectedUsers if we already have tiles initialized
            setSelectedUsers((prev) => {
                if (!prev || !prev.length) return prev;

                const updated = prev.map((tile) => {
                    // find matching key in the SSE data (ids may be UUID strings)
                    const matchKey = Object.keys(data).find((k) => String(k) === String(tile.id));
                    if (!matchKey) return tile; // no update for this tile

                    const readings = data[matchKey];
                    if (!readings || !readings.length) {
                        // No new readings – keep the previous values (like MainTable updatedUserData)
                        return tile;
                    }

                    const last = readings[readings.length - 1];

                    const newVals = {
                        air_quality: last.air_quality ?? tile.air_quality ?? "--",
                        heart_rate: last.heart_rate ?? tile.heart_rate ?? "--",
                        spo2: last.spo2 ?? tile.spo2 ?? "--",
                        pi: last.pi ?? tile.pi ?? "--",
                        hrv: last.hrv ?? tile.hrv ?? "--",
                        altitude: last.altitude ?? tile.altitude ?? "--",
                        humidity: last.humidity ?? tile.humidity ?? "--",
                        battery_level: last.battery_level ?? tile.battery_level ?? "--",
                        temp: last.temp ?? tile.temp ?? "--",
                        vo2: last.vo2 ?? tile.vo2 ?? "--",
                        spv: last.spv ?? tile.spv ?? "--",
                        hrr: last.hrr ?? tile.hrr ?? "--",
                        biometric_pressure: last.biometric_pressure ?? tile.biometric_pressure ?? "--",
                        signal_quality: last.signal_quality ?? tile.signal_quality ?? null,
                        reading_time: last.reading_time ?? tile.reading_time ?? null,
                    };

                    // If none of the displayed metric values changed, return original tile to avoid re-render
                    if (
                        newVals.air_quality === tile.air_quality &&
                        newVals.heart_rate === tile.heart_rate &&
                        newVals.spv === tile.spv &&
                        newVals.pi === tile.pi &&
                        newVals.hrv === tile.hrv
                    ) {
                        return tile;
                    }

                    return {
                        ...tile,
                        ...newVals,
                    };
                });

                // If no tile object identity changed, return prev to avoid triggering re-render
                let anyChange = false;
                for (let i = 0; i < prev.length; i++) {
                    if (prev[i] !== updated[i]) {
                        anyChange = true;
                        break;
                    }
                }
                return anyChange ? updated : prev;
            });
        }
    }, [setSelectedUsers]);

    // Handle SSE errors
    const handleSSEError = React.useCallback((error) => {
        console.error('SSE Error:', error);
    }, []);

    const memberIds = (item.selectedPlayers || [])
		.map(m => m?.user_id || m?.member_id || m?.id)
		.filter(Boolean)
		.join(',');
	const sseUrl = `/group/data?members=${encodeURIComponent(memberIds)}`;

    // // Use SSE hook
    useSSE(
        sseUrl,
        handleSSEData,
        handleSSEError
    );

    

    useEffect(() => {

        const selectedPlayers = (item && item.selectedPlayers) || [];
         
        if (selectedPlayers && selectedPlayers.length) {
        let tiles = selectedPlayers.map((p, i) => {
            const name = `${p.first_name || p.firstName || p.name || ''} ${p.last_name || p.lastName || ''}`.trim();
            const id = p.user_id || p.member_id || p.id || i + 1;
            return {
                id,
                name: name || `Person ${i + 1}`,
                avatar: p?.avatar_url || p?.avatar || '',
                air_quality: "--",
                heart_rate: "--",
                spo2: "--",
                pi: "--",
                hrv: "--",
                // additional fields
                altitude: "--",
                humidity: "--",
                battery_level: "--",
                temp: "--",
                vo2: "--",
                spv: "--",
                hrr: "--",
                biometric_pressure: "--",
                signal_quality: null,
                reading_time: null,
            };
        });

        setSelectedUsers(tiles);
    } else {
        // fallback to 6 placeholders
        let tiles = Array.from({ length: 6 }).map((_, i) => ({
            id: i + 1,
            name: location.state?.first_name ? `${location.state.first_name} ${location.state.last_name || ''}` : `Person ${i + 1}`,
            avatar: location.state?.avatar_url || '',
            air_quality: "--",
                heart_rate: "--",
                spo2: "--",
                pi: "--",
                hrv: "--",
                altitude: "--",
                humidity: "--",
                battery_level: "--",
                temp: "--",
                vo2: "--",
                spv: "--",
                hrr: "--",
                biometric_pressure: "--",
                signal_quality: null,
                reading_time: null,
        }));

        setSelectedUsers(tiles);
    }
        
    }, [item.selectedPlayers, location.state, item]);

    return (
        <div>
            {/* <AddPrivateNote setOpen={setOpen} open={open} players_id={item?.user_id} /> */}
            

            <div className={styles.page}>
                <div className={styles.pageHeader}>
                    <button
                        className={styles.closeBtn}
                        aria-label="close"
                        onClick={() => setShowExitConfirm(true)}
                    >
                        ×
                    </button>
                </div>

                {selectedUsers.length > 4 ? (
                        <div className={styles.grid}>
                            {selectedUsers.map((player, index) => (
                                <CardSmall
                                    key={player.id || player.user_id || index}
                                    name={
                                        `${player.first_name || player.firstName || player.name || ""} ${
                                            player.last_name || player.lastName || ""
                                        }`.trim() || "Person"
                                    }
                                    avatarUrl={player.avatar_url || player.avatar}
                                    air_quality={player.air_quality}
                                    spo2={player.spo2 ?? player.oxygen}
                                    heart_rate={player.heart_rate}
                                    spv={player.spv}
                                    pi={player.pi}
                                    hrv={player.hrv}
                                    altitude={player.altitude}
                                    humidity={player.humidity}
                                    temp={player.temp}
                                    onClick={() => openIndividualView(player)}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className={styles.gridFour}>
                            {selectedUsers.map((player, index) => (
                                <CardLarge
                                    key={player.id || player.user_id || index}
                                    name={
                                        `${player.first_name || player.firstName || player.name || ""} ${
                                            player.last_name || player.lastName || ""
                                        }`.trim() || "Person"
                                    }
                                    avatarUrl={player.avatar_url || player.avatar}
                                    air_quality={player.air_quality}
                                    spo2={player.spo2 ?? player.oxygen}
                                    heart_rate={player.heart_rate}
                                    spv={player.spv}
                                    pi={player.pi}
                                    hrv={player.hrv}
                                    altitude={player.altitude}
                                    humidity={player.humidity}
                                    temp={player.temp}
                                    onClick={() => openIndividualView(player)}
                                />
                            ))}
                        </div>
                    )}

                <ExitConfirmDialog
                    open={showExitConfirm}
                    onClose={() => setShowExitConfirm(false)}
                    onConfirm={handleConfirmExit}
                    title="Are you sure you want to exit?"
                />

            </div>
        </div>
    );
}
